// import React, { useState, useEffect } from 'react';
// import { db, collection } from '../firebase';
// import { getDocs, updateDoc, doc,query, where } from 'firebase/firestore';
// import './ManageItems_giv.css';

// const ManageItems = () => {
//   const [items, setItems] = useState([]);

//   const fetchUncheckedItems = async () => {
//     const q = query(collection(db, 'items_giv'), where('status', '==', 'unchecked'));
//     const querySnapshot = await getDocs(q);
//     setItems(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
//   };

//   useEffect(() => {
//     fetchUncheckedItems();
//   }, []);

//   const handleStatusChange = async (itemId, status) => {
//     await updateDoc(doc(db, 'items_giv', itemId), { status });
//     fetchUncheckedItems(); // Refresh the list
//   };

//   return (
//     <div className="manage-items-container">
//       <h2>ניהל מודעות</h2>
//       <div className="status-info">
//         <p>פריטים שלא נבדקו : <span>{items.length}</span></p>
//       </div>
//       <div className="items-list">
//         {items.map(item => (
//           <div key={item.id} className="item-card">
//             <img src={item.picture} alt={item.name} className="item-image" />
//             <div className="item-details">
//               <h3>{item.name}</h3>
//               <p>{item.condition}</p>
//               <div className="action-buttons">
//                 <button className="check-button" onClick={() => handleStatusChange(item.id, 'checked')}>אישור</button>
//                 <button className="unconfirm-button" onClick={() => handleStatusChange(item.id, 'unconfirmed')}>דחיה</button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ManageItems;



import React, { useState, useEffect } from 'react';
import { db, collection } from '../firebase';
import { getDocs, updateDoc, deleteDoc, doc, query, where } from 'firebase/firestore';
import './ManageItems_giv.css';

const ManageItems = () => {
  const [items, setItems] = useState([]);
  const [showAllItems, setShowAllItems] = useState(false);

  const fetchItems = async (status = 'unchecked') => {
    let q;
    if (status === 'all') {
      q = collection(db, 'items_giv');
    } else {
      q = query(collection(db, 'items_giv'), where('status', '==', status));
    }
    const querySnapshot = await getDocs(q);
    setItems(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleStatusChange = async (itemId, status) => {
    await updateDoc(doc(db, 'items_giv', itemId), { status });
    fetchItems(showAllItems ? 'all' : 'unchecked'); // Refresh the list
  };

  const handleDelete = async (itemId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await deleteDoc(doc(db, 'items_giv', itemId));
      fetchItems(showAllItems ? 'all' : 'unchecked'); // Refresh the list
    }
  };

  const toggleShowAllItems = () => {
    setShowAllItems(!showAllItems);
    fetchItems(!showAllItems ? 'all' : 'unchecked');
  };

  return (
    <div className="manage-items-container">
      <h2>ניהול מודעות</h2>
      <div className="status-info">
        <p>פריטים שלא נבדקו: <span>{items.length}</span></p>
        <button onClick={toggleShowAllItems}>
          {showAllItems ? 'הצג פריטים שלא נבדקו' : 'הצג כל הפריטים'}
        </button>
      </div>
      <div className="items-list">
        {items.map(item => (
          <div key={item.id} className="item-card">
            <img src={item.picture} alt={item.name} className="item-image" />
            <div className="item-details">
              <h3>{item.name}</h3>
              <p>{item.condition}</p>
              <div className="action-buttons">
                <button className="check-button" onClick={() => handleStatusChange(item.id, 'checked')}>אישור</button>
                <button className="unconfirm-button" onClick={() => handleStatusChange(item.id, 'unconfirmed')}>דחיה</button>
                <button className="delete-button" onClick={() => handleDelete(item.id)}>מחיקה</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageItems;

